module.exports = __webpack_public_path__ + "img/icon-no-start.8309c4eb.png";